import { cardsData } from '@/mocks/homepage';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100/80 text-secondary-700 text-xs font-medium mb-4">
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-layout-grid-line text-sm"></i>
            </div>
            精选推荐
          </div>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 font-heading mb-3">
            本周精选影视内容
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            电影大全编辑团队精心策划，为你甄选值得一看的影视内容与平台动态
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {cardsData.map((card) => (
            <article
              key={card.id}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-accent-200 transition-all cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-3">
                  <span className="px-2.5 py-0.5 rounded-md bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap">
                    {card.tag}
                  </span>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{card.date}</span>
                </div>
                <h3 className="text-base md:text-lg font-bold text-foreground-900 font-heading mb-2 group-hover:text-accent-600 transition-colors line-clamp-2">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3">
                  {card.summary}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}